"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _pragma = require("../../../pragma");

var React = _interopRequireWildcard(require("react"));

var _ = require("../..");

var css = _interopRequireWildcard(require("./InsightBarChart.style"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * The InsightBarChart component renders a noninteractive bar graph and a small
 * set of accompanying data to add context. As an example, it's used on the
 * 'My Performance' page to compare the last two years of annual returns.
 *
 * The scale for the Bar Graph is determined by the `ceiling` prop, where the
 * maximum scale is the largest data value rounded up to the nearest ceiling
 * value interval. (eg, if the largest `data` y value is 1500, and the `ceiling`
 * prop value is 1000, then the max value on the graph will be 2000).
 *
 * If multiple lines of content need to be rendered for the title,value, or
 * explanation props, you may pass in pre-formatted JSX (eg, multiple `Text`
 * components).
 */
const InsightBarChart = ({
  ceiling = 1000,
  data = [],
  explanation,
  title,
  value,
  ...otherProps
}) => {
  const valueMax = Math.max(...data.map(({
    y
  }) => y));
  const chartMax = Math.ceil(valueMax / ceiling) * ceiling;
  return (0, _pragma.createFelaElement)(_.View, _extends({
    flexDirection: "column"
  }, otherProps), (0, _pragma.createFelaElement)(_.Text, {
    children: title
  }), (0, _pragma.createFelaElement)(_.View, {
    alignItems: "stretch",
    css: css.chart,
    margin: ['xsmall', 'none', 'xxxlarge'],
    padding: ['none', 'large']
  }, data.map(({
    x,
    y
  }, i) => {
    const height = "".concat(Math.round(y / chartMax * 100), "%");
    return (0, _pragma.createFelaElement)(_.View, {
      alignItems: "center",
      flexDirection: "column",
      justifyContent: "flex-end",
      margin: i > 0 ? ['none', 'none', 'none', 'xlarge'] : undefined,
      key: "".concat(y).concat(i) // eslint-disable-line react/no-array-index-key

    }, (0, _pragma.createFelaElement)(_.Text, {
      children: x,
      variant: "meta"
    }), (0, _pragma.createFelaElement)("div", {
      "aria-label": "".concat(y),
      css: css.bar,
      cssProps: {
        odd: i % 2 === 1
      },
      style: {
        height
      }
    }));
  })), (0, _pragma.createFelaElement)(_.View, {
    flexDirection: "column",
    gap: "xsmall"
  }, (0, _pragma.createFelaElement)(_.Text, {
    as: "div",
    children: value,
    variant: "bodyBold"
  }), (0, _pragma.createFelaElement)(_.Text, {
    as: "div",
    children: explanation,
    variant: "meta"
  })));
};

InsightBarChart.displayName = 'InsightBarChart';
var _default = InsightBarChart;
exports.default = _default;
//# sourceMappingURL=InsightBarChart.js.map